import Editor from './editor';
import md from '../../../const/meta/others';

export default {
  Editor,
  md: md.users,
};
